import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ContentCtx = createContext({ c: (k, f) => f });

export const ContentProvider = ({ children }) => {
  const [items, setItems] = useState({});
  useEffect(() => {
    axios.get(`${API}/content`).then((r) => setItems(r.data.items || {})).catch(() => {});
  }, []);
  const c = (key, fallback = "") => (items[key] !== undefined && items[key] !== "" ? items[key] : fallback);
  return <ContentCtx.Provider value={{ c }}>{children}</ContentCtx.Provider>;
};

export const useContent = () => useContext(ContentCtx);
